
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.4 0H2.6A2.6 2.6 0 000 2.6v18.8A2.6 2.6 0 002.6 24h18.8a2.6 2.6 0 002.6-2.6V2.6A2.6 2.6 0 0021.4 0zM23 21.4a1.6 1.6 0 01-1.6 1.6H2.6A1.6 1.6 0 011 21.4V2.6A1.6 1.6 0 012.6 1h18.8A1.6 1.6 0 0123 2.6z"}}),_c('path',{attrs:{"d":"M5.46 6.17H18.4a.5.5 0 000-1H5.46a.5.5 0 000 1zm.86 3.23a2.33 2.33 0 102.33 2.34A2.33 2.33 0 006.32 9.4zm0 3.67a1.33 1.33 0 111.33-1.33 1.33 1.33 0 01-1.33 1.33zm5.75-3.67a2.33 2.33 0 102.33 2.34 2.33 2.33 0 00-2.33-2.33zm0 3.67a1.33 1.33 0 111.33-1.33 1.33 1.33 0 01-1.33 1.33zm5.75 1a2.33 2.33 0 10-2.33-2.33 2.33 2.33 0 002.33 2.33zm0-3.66a1.33 1.33 0 11-1.33 1.33 1.33 1.33 0 011.33-1.33zm-11.5 4.71a2.33 2.33 0 102.33 2.33 2.33 2.33 0 00-2.33-2.33zm0 3.66a1.33 1.33 0 111.33-1.34 1.33 1.33 0 01-1.33 1.33zm5.75-3.66a2.33 2.33 0 102.33 2.33 2.33 2.33 0 00-2.33-2.33zm0 3.66a1.33 1.33 0 111.33-1.34 1.33 1.33 0 01-1.33 1.33zm5.94-3.66a2.33 2.33 0 102.33 2.33 2.33 2.33 0 00-2.33-2.33zm0 3.66a1.33 1.33 0 111.33-1.34 1.33 1.33 0 01-1.33 1.33z"}})])
          )
        }
      }
    